export const COLLISION_MARGIN = 80;